'use strict'

const debug = require('debug')('metronome-utils:army-knife')
const metadata = require('vesper-metadata')
const pTap = require('p-tap')

const { handleForkedChainId } = require('./utils')
const makAbi = require('./abi/mini-army-knife.json')

/**
 * Create a Mini Army Knife helper object.
 *
 * @param {object} web3 A Web3 instance.
 * @returns {object} The helper.
 */
const createArmyKnife = function (web3) {
  const makAddressPromise = web3.eth
    .getChainId()
    .then(handleForkedChainId)
    .then(
      chainId =>
        metadata.support.find(
          c => c.name === 'MiniArmyKnife' && c.chainId === chainId
        )?.address
    )

  const getMakAddress = () => makAddressPromise

  const makContractPromise = makAddressPromise.then(
    makAddress => new web3.eth.Contract(makAbi, makAddress)
  )

  const getMakContract = () => makContractPromise

  const canTransfer = function (from, to, defaultBlock) {
    debug(
      'Checking if it is possible to transfer funds from %s to %s.',
      from,
      to
    )
    return makContractPromise
      .then(armyKnife =>
        armyKnife.options.address
          ? armyKnife.methods.validPath(from, to).call({}, defaultBlock)
          : false
      )
      .catch(function (err) {
        debug('Transfer check failed: %s', err.message)
        return false
      })
      .then(
        pTap(canMoveFunds =>
          debug(
            '%s %s move funds to %s',
            from,
            canMoveFunds ? 'can' : `can't`,
            to
          )
        )
      )
  }

  return {
    canTransfer,
    getMakAddress,
    getMakContract
  }
}

module.exports = createArmyKnife
